// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__zmDiD","aside":"Navigation_aside__G33Mp","list":"Navigation_list__mACqG","listItem":"Navigation_listItem__robKl"};